import React from 'react'
import PropTypes from 'prop-types'
import { Menu } from 'semantic-ui-react'
import NavItem from './NavItem'
import { css } from 'emotion'

export default class NavPanel extends React.Component {
  render() {
    return (
      <Menu vertical className={style}>
        <NavItem icon='home' url='/home' text='Home' minimal={this.props.collapsed} />
        <NavItem icon='first order' url='/create-order' text='Item / Order Creation' minimal={this.props.collapsed} /> 
        { this.props.cdpEnabled == 'true' ? <NavItem icon='first order' url='/create-cdp-order' text='Cross Divisional Purchase' minimal={this.props.collapsed} /> : null }
      </Menu>
    )
  }
}

NavPanel.propTypes = {
  collapsed: PropTypes.bool
}


const style = css`
  & {
    width: auto !important;
  }`


// WEBPACK FOOTER //
// ./components/nav-panel/NavPanel.js